<template>
  <div id="root" :class="{'no-justify': hasBannerHelp}">

    <div :class="{'hasShift': true, 'shiftLeft': isNavOpen}">
      <app-header
        @update-props="updateProps"></app-header>
    </div>

    <div class="mainOverlay"
         v-if="isNavOpen"
         @click="closeNav"></div>

    <app-nav v-show="isNavOpen"></app-nav>

    <div :style="{'left': setBubblePosition}"
         v-show="isNotFullscreen"
         class="bubble bubble--left"></div>

    <component v-if="isChildPopulated"
               :is="currentComponent.component"
               :currentVariant="currentComponent.name"
               @update-props="updateProps"
               :class="{'shiftLeft': isNavOpen, 'main-block': true}"
               @open-overlay="openOverlay"
               :dataObj="currentData"></component>

    <div :style="{'right': setBubblePosition}"
         v-show="isNotFullscreen"
         class="bubble bubble--right"></div>

    <transition :name="checkTemplate">
      <banner-help v-if="hasBannerHelp"></banner-help>
    </transition>

    <transition name="slideFromBottom">
      <view-ad v-if="hasAdvertisment"
               :adConfig="advertismentConfig"></view-ad>
    </transition>

    <info-overlay v-if="isOverlayActive"
                  :infoConfig="infoOverlay"
                  @close-overlay="closeOverlay"></info-overlay>

    <app-spinner v-if="isApplicationLoading"></app-spinner>

  </div>
</template>

<script>
  //Global components
  import Header         from './components/globals/Header.vue';
  import Nav            from './components/globals/Menu.vue';
  import BannerHelp     from './components/globals/BannerHelp.vue';
  import LoadingSpinner from './components/globals/Spinner.vue';
  import Advertisment   from './components/globals/Advertisment.vue';
  //Start component
  import Start          from './components/start/Start.vue';
  //Question component
  import Question       from './components/question/Question.vue';
  //Range slider component
  import Range          from './components/range/Range.vue';
  //Info component
  import InfoOverlay    from './components/info/Overlay.vue';
  //Input components
  import Area           from './components/input/Area.vue';
  import Cap            from './components/input/Cap.vue';
  import Power          from './components/input/Power.vue';
  //Alert component
  import Alert          from './components/alert/Alert.vue';
  //Summary component
  import Summary        from './components/summary/Summary.vue';
  //Help components
  import HelpStandard   from './components/help/Standard.vue';
  import HelpAlternate  from './components/help/Alternate.vue';
  //Loop component
  import Loop           from './components/loop/Loop.vue';
  //E-commerce components
  import ProductListing from './components/ecommerce/ProductListing.vue';
  import ProductCart    from './components/ecommerce/ProductCart.vue';

  export default {
    data () {
      return {
        currentComponent: null,
        currentVariant: null,
        currentData: {},
        infoOverlay: {},
        isOverlayActive: false,
        isNotFullscreen: true
      }
    },
    components: {
      'app-header':           Header,
      'app-nav':              Nav,
      'app-spinner':          LoadingSpinner,
      'banner-help':          BannerHelp,
      'info-overlay':         InfoOverlay,
      'view-ad':              Advertisment,
      'start-standard':       Start,
      'question-standard':    Question,
      'range-standard':       Range,
      'input-area':           Area,
      'input-cap':            Cap,
      'input-power':          Power,
      'summary-system':       Summary,
      'summary-room':         Summary,
      'summary-split':        Summary,
      'summary-engine':       Summary,
      'summary-power':        Summary,
      'alert-standard':       Alert,
      'help-standard':        HelpStandard,
      'help-alternate':       HelpAlternate,
      'loop-standard':        Loop,
      'product-listing':      ProductListing,
      'product-cart':         ProductCart
    },
    computed: {
      setBubblePosition(){
        var windowWidth = window.innerWidth;
        windowWidth = (windowWidth - 1000) / 2;
        return windowWidth + 'px';
      },
      isNavOpen(){
        return this.$store.state.isNavOpen;
      },
      isApplicationLoading(){
        return this.$store.state.isApplicationLoading;
      },
      hasBannerHelp(){
        return this.$store.state.hasBannerHelp;
      },
      hasAdvertisment(){
        return this.$store.state.hasAdvertisment;
      },
      isChildPopulated(){
        return this.$store.state.hasMainView;
      },
      getVariantClass(){
        return this.currentVariant;
      },
      checkTemplate(){
        if (this.$store.state.tempConfigObj.template !== 'help_stnd_b') {
          return 'slideFromBottom';
        }
        else {
          return 'slideFromRight';
        }
      }
    },
    methods: {
      isFullscreen(template){
        console.log(template);
        this.isNotFullscreen = template != 'alert_stnd';
      },
      checkBubblePosition(){
        var windowWidth = window.innerWidth,
          pos;
        windowWidth = (windowWidth - 1000) / 2;
        pos = windowWidth + 'px';
        $('.bubble--left').css('left', pos);
        $('.bubble--right').css('right', pos);
      },
      closeNav(){
        this.$store.state.isNavOpen = false;
      },
      openOverlay(infoConfigObj){
        var vm = this;
        vm.infoOverlay = infoConfigObj;
        vm.isOverlayActive = true;
      },
      closeOverlay(){
        var vm = this;
        vm.infoOverlay = {};
        vm.isOverlayActive = false;
      },
      updateProps(props){
        // Updates props dynamically when child components make AJAX call
        var vm = this;
        vm.$store.state.templates.forEach(function (elem) {
          if (elem.name == props.template) {
            vm.isFullscreen(elem.name);
            vm.currentData = props;
            vm.currentComponent = elem;
            if (elem.variant) {
              if (elem.variant == vm.$store.state.tempConfigObj.template) {
                vm.isChildPopulated = false;
              }
              vm.currentVariant = elem.name;
              vm.isChildPopulated = true;
            }
          }
        });
      },
      initCall(){

        // Make initialization call
        var vm = this;
        vm.$store.state.isApplicationLoading = true;
        $.ajax({
          url: vm.$store.state.routes.initURL,
          crossDomain: true,
          xhrFields: {
            withCredentials: true
          },
          success: function (res) {
            vm.$store.state.isApplicationLoading = false;
            if (res.result == 'success' && res.code == 200) {

              // Cycle through templates and print the correct one
              // Should be 'start'

              vm.$store.state.templates.forEach(function (elem) {
                if (elem.name == res.response.template) {

                  // If correct template, render it and render component block for the first time
                  // (This is used to avoid warnings in console)

                  vm.currentData = res.response;
                  vm.currentComponent = elem;
                  if (elem.variant) {
                    vm.currentVariant = elem.name;
                  }
                  vm.$store.state.hasMainView = true;
                }

                if (res.response.advertisment) {
                  if (res.response.advertisment.image || res.response.advertisment.products) {
                    vm.$store.state.advertismentConfig = res.response.advertisment;
                    vm.$store.state.hasAdvertisment = true;
                  }
                  else {
                    vm.$store.state.advertismentConfig = {};
                    vm.$store.state.hasAdvertisment = false;
                  }
                }
                else {
                  vm.$store.state.advertismentConfig = {};
                  vm.$store.state.hasAdvertisment = false;
                }
              });
            }
          },
          error: function (err) {
            console.log('Error: ' + err);
          }
        })
      },
      isLandscape() {
        return (window.orientation === 90 || window.orientation === -90);
      }
    },
    mounted(){
      var vm = this;
      setTimeout(function () {
        window.scrollTo(0, 1);
      }, 0);
      if (vm.isLandscape()) {
        $('html').addClass('landscape');
      }
      else {
        $('html').removeClass('landscape');
      }
      $(window).on('orientationchange', vm.isLandscape);
      $(window).on('resize', vm.checkBubblePosition);
      this.initCall();
    }
  }
</script>



// WEBPACK FOOTER //
// src/App.vue